import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { ExitIcon, SettingsIcon, ShareIcon } from "@/assets"
import { invalidateAllGameStates } from "@/helpers/invalidateAllGameStates"
import { openTgLink } from "@/helpers/openTgLink"
import { ROUTES } from "@/helpers/routes"
import { useModals } from "@/modals"
import { useGame } from "@/providers/GameProvider"
import { useAppDispatch } from "@/store/index"
import { Button } from "@/ui/Button"
import styles from "./GameMenu.module.scss"

export const GameMenu: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { openModal, closeAllModals } = useModals()

  const { isMatchActive, isMatchPending, sessionId } = useGame()

  const handleSettingsMatch = () => {
    openModal("matchSettings")
  }

  const handleLogs = () => {
    openModal("matchLogs")
  }

  const handleExit = () => {
    invalidateAllGameStates(dispatch)
    navigate(ROUTES.HOME, { replace: true })
    closeAllModals()
  }

  const handleShare = () => {
    const text = t("shareMatch")
    const linkToGame = encodeURIComponent(
      `https://t.me/${import.meta.env.VITE_BOTNAME}/${
        import.meta.env.VITE_WEBAPP_NAME
      }?startapp=match_${sessionId}`
    )
    const link = `${encodeURI(
      `https://t.me/share/url?text=${text}&url=`
    )}${linkToGame}`

    openTgLink(link)
  }

  if (isMatchPending) return null

  return (
    <div className={clsx(styles.GameMenu)}>
      <div className={clsx(styles.GameMenu_buttons)}>
        {!isMatchPending && (
          <Button.Ring
            icon={<SettingsIcon />}
            className={clsx(styles.GameMenu_button, styles.flag)}
            onClick={handleSettingsMatch}
          />
        )}
        <Button
          className={clsx(styles.GameMenu_button, styles.log)}
          styles="orange-3d"
          onClick={handleLogs}
        >
          {t("logs.title")}
        </Button>
        {!isMatchActive && !isMatchPending && (
          <Button.Ring
            className={clsx(styles.GameMenu_button, styles.share)}
            onClick={handleShare}
          >
            <ShareIcon />
          </Button.Ring>
        )}
      </div>
      <div className={clsx(styles.GameMenu_buttons)}>
        {!isMatchActive && !isMatchPending && (
          <>
            <Button.Ring
              className={clsx(styles.GameMenu_button, styles.exit)}
              styles="red"
              onClick={handleExit}
            >
              <ExitIcon />
            </Button.Ring>
          </>
        )}
      </div>
    </div>
  )
}
